<template lang="pug">
#bloco-inserir-dados-contrato-originacao-planilha
    h1 Inserir dados do contrato de originação via planilha
    el-card
        .box-card-inserir-dados-planilha
            .box-card-inserir-dados-planilha__conteudo
                .box-card-inserir-dados-planilha__conteudo__bloco
                    span Para agilizar seu processo, você pode adicionar os imóveis de uma vez só atravez de uma planilha. <br> Ela deve conter os seguintes campos:

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__lista
                        ul
                            li CAR
                            li Volume
                            li CPF/CNPJ

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__buttons
                        span.btn-download(@click='downloadPlanilhaExemplo()')
                            i.mdi.mdi-download
                            span Baixar modelo de planilha

                        el-upload.upload-demo(
                            action='#',
                            :auto-upload='false',
                            :show-file-list='false',
                            :on-change='enviarPlanilha',
                            :on-exceed='onExceed',
                            :limit='1',
                            ref='uploadPlanilhaTerritorio'
                        )
                            span
                                el-button(
                                    icon='el-icon-upload2',
                                    type='primary'
                                ) Inserir planilha

                div(v-if='dadosLote')
                    hr
                    .bloco-inserir-contrato-originacao-planilha-lote-importada
                        .bloco-inserir-contrato-originacao-planilha-lote-importada_bloco
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Planilha importada
                            el-tooltip(
                                effect='dark',
                                :content='dadosLote.planilha',
                                placement='top'
                            )
                                span.bloco-inserir-contrato-originacao-planilha-lote-importada_nome
                                    | {{ dadosLote.planilha }}
                        .bloco-inserir-contrato-originacao-planilha-lote-importada_bloco
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Data de cadastro
                            span.bloco-inserir-contrato-originacao-planilha-lote-importada_data
                                    | {{ dadosLote.dataCadastro }}
                        .bloco-inserir-contrato-originacao-planilha-lote-importada_bloco(
                            v-if='dadosLote.planilhaErro && dadosLote.statusCodigo !== "ERRO_PROCESSAR"'
                        )
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Planilha com erro
                            el-button.bloco-inserir-contrato-originacao-planilha-lote__button(
                                type='primary',
                                size='mini',
                                icon='el-icon-download',
                                @click='fazerDownload(dadosLote.id)'
                            ) Fazer download
                        .bloco-inserir-contrato-originacao-planilha-lote-importada_bloco
                            span.bloco-inserir-contrato-originacao-planilha-lote__label Status
                            el-tag.bloco-inserir-contrato-originacao-planilha-lote__status(
                                v-if='dadosLote.statusCodigo === "EM_PROCESSAMENTO"',
                                type='info',
                                size='small'
                            )
                                i.el-icon-loading(
                                    v-if='dadosLote.statusCodigo === "EM_PROCESSAMENTO"'
                                )
                                | {{ dadosLote.status }}
                            el-tag.bloco-inserir-contrato-originacao-planilha-lote__status(
                                v-if='dadosLote.statusCodigo === "PROCESSADO_COM_ERRO"',
                                type='warning',
                                size='small'
                            ) {{ dadosLote.status }}
                            el-tag.bloco-inserir-contrato-originacao-planilha-lote__status(
                                v-if='dadosLote.statusCodigo === "PROCESSADO"',
                                type='success',
                                size='small'
                            ) {{ dadosLote.status }}
                            el-tag.bloco-inserir-contrato-originacao-planilha-lote__status(
                                v-if='dadosLote.statusCodigo === "ERRO_PROCESSAR"',
                                type='danger',
                                size='small'
                            ) {{ dadosLote.status }}
                div(v-else)
                    hr
                    br
                    p Nenhuma planilha enviada para esse contrato de originação!
</template>

<script>
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoInserirDadosPlanilha',

    emits: ['atualizarTabelaTerritorios'],

    props: {
        numeroContrato: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            dadosLote: null
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.buscarDadosLote();
        this.conectarCanalNotificacaoProcessamento();
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: 'Só é permitido o upload de um arquivo por vez.',
                position: 'top-left'
            });
        },

        async enviarPlanilha(planilha) {
            if (
                this.dadosLote &&
                this.dadosLote.statusCodigo === 'EM_PROCESSAMENTO'
            ) {
                this.$notify.warning({
                    message:
                        'Não é possivel realizar um novo cadastro, pois existe um em processamento.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: 'Esse arquivo ultrapassa 15MB.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx') {
                this.$notify.error({
                    message:
                        'Apenas arquivos com a extensão XLSX são suportados.'
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            try {
                this.$notify.success({
                    message: 'Arquivo está sendo enviado.'
                });
                await ContratoOriginacaoServiceSubEmpresa.cadastrarTerritoriosViaPlanilha(
                    planilha,
                    this.numeroContrato
                );
                this.$notify.success({
                    message:
                        'Arquivo enviado com sucesso. O processamento será concluído em breve.'
                });
                this.buscarDadosLote();
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar upload do arquivo.'
                });
            }
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            link.setAttribute('download', 'planilha-exemplo-territorio');
            link.href =
                'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-territorio.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        async buscarDadosLote() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscarDadosLoteSubEmpresa(
                        this.numeroContrato
                    );
                if (data) {
                    this.dadosLote = data;
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar dados de processamento.'
                });
            }
        },

        fazerDownload(id) {
            ContratoOriginacaoServiceSubEmpresa.downloadPlanilhaComErroSubEmpresa(
                id
            )
                .then(() => {
                    this.$notify.success({
                        message: 'Download realizado com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar download!'
                    });
                });
        },

        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: 'Não foi possível se conectar na api!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/contrato-originacao/territorio/lote`,
                    response => {
                        this.dadosLote = JSON.parse(response);
                        this.$notify.success({
                            message: 'O processamento foi atualizado.'
                        });
                        this.$emit('atualizarTabelaTerritorios');
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível exportar o pdf!'
                });
                disconnect();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-inserir-dados-contrato-originacao-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .lista {
        display: flex;
        flex-direction: row;
    }

    .el-card.is-always-shadow {
        min-height: 370px;
    }

    el-card {
        margin-top: 10px;
    }

    .box-card-inserir-dados-planilha{
        height: 333px;
    }
    .box-card-inserir-dados-planilha__conteudo {
        display: flex;
        flex-direction: column;
        min-height: 297px;
        justify-content: space-between;
        font-size: 16px;
        gap: 15px;

        .box-card-inserir-dados-planilha__conteudo__bloco {
            display: flex;
            .box-card-inserir-dados-planilha__conteudo__bloco__buttons {
                display: flex;
                gap: 15px;
                width: 100%;
                justify-content: flex-end;
                align-items: center;
                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }

            .box-card-inserir-dados-planilha__conteudo__bloco__lista {
                ul {
                    margin-bottom: 15px;
                }
                li::after {
                    content: ' *';
                    color: #f56c6c;
                }
            }
        }
    }

    .bloco-inserir-contrato-originacao-planilha-lote-importada {
        display: flex;
        justify-content: space-between;

        .bloco-inserir-contrato-originacao-planilha-lote-importada_bloco {
            font-size: 12px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            max-width: 34%;
        }

        .bloco-inserir-contrato-originacao-planilha-lote__label {
            font-weight: bold;
            color: var(--primary);
        }

        .bloco-inserir-contrato-originacao-planilha-lote-importada_nome {
            display: inline-block;
            width: 120px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }

        .bloco-inserir-contrato-originacao-planilha-lote__status {
            font-size: 11px;
        }
        .bloco-inserir-contrato-originacao-planilha-lote__button {
            font-size: 11px;
        }

        .bloco-inserir-contrato-originacao-planilha-lote-importada_data {
            display: inline-block;
            width: 100px;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            margin-top: 4px;
        }
    }
}
</style>
